import { createAsyncThunk } from "@reduxjs/toolkit";
// Utilities
import HttpClient from 'utilities/HttpClient';
import { getContent } from "utilities/Utilities";

const { accountId } = getContent('settings');

export default class PropertyOwnershipsAsync {
  private static _url:string = '/client/propertyOwnerships';
  private static _http:HttpClient = new HttpClient();

  // Fetch property ownerships (search)
  public static fetchPropertyOwnerships = createAsyncThunk('propertyOwnerships/fetchPropertyOwnerships', async (params:any, thunkApi) => {
    const nextParams = { accountId, ...params };
    const response:Response = await this._http.get(`${this._url}/search`, nextParams);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });

  // Fetch property ownership (by id)
  public static fetchPropertyOwnership = createAsyncThunk('propertyOwnerships/fetchPropertyOwnership', async (propertyOwnershipId:number, thunkApi) => {
    const response:Response = await this._http.get(`${this._url}/${propertyOwnershipId}`);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });

  // Fetch my property ownerships
  public static fetchMyPropertyOwnerships = createAsyncThunk('propertyOwnerships/fetchMyPropertyOwnerships', async (params:any, thunkApi) => {
    const response:Response = await this._http.get(this._url, params);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });

  // Create property ownership
  public static createPropertyOwnerships = createAsyncThunk('propertyOwnerships/createPropertyOwnerships', async (data:any, thunkApi) => {
    const response:Response = await this._http.post(this._url, data);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });

  // Update property ownership
  public static updatePropertyOwnerships = createAsyncThunk('propertyOwnerships/updatePropertyOwnerships', async (propertyOwnershipData:any, thunkApi) => {
    const { id, ...data } = propertyOwnershipData;
    const response:Response = await this._http.put(`${this._url}/${id}`, data);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });


  // Delete property ownership
  public static deletePropertyOwnerships = createAsyncThunk('propertyOwnerships/deletePropertyOwnerships', async (propertyOwnershipId:number, thunkApi) => {
    const response:Response = await this._http.delete(`${this._url}/${propertyOwnershipId}`);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    // return response.json();
 
  });

  // Fetch property ownerships / groups
  public static fetchPropertyOwnershipsGroups = createAsyncThunk('propertyOwnerships/fetchPropertyOwnerships/groups', async (params:any, thunkApi) => {
    const nextParams = { accountId, ...params };
    const response:Response = await this._http.get(`${this._url}/groups`, nextParams);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });
}
